import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import {Link, useParams} from "react-router-dom";
import { viewBuyer, updateBuyer, clearBuyerMsg } from "../../actions/buyerAction";
import { countriesAction } from "../../actions/commonActions";


const BuyerUpdate = (props) => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [error, setError] = useState(false);

    const [countryList, setCountryList] = useState([]);

    const [buyerDetails, setBuyerDetails] = useState({
        id:"", buyer_name: "", email: "", address: "", city: "", country: "", phone_no: ""
    });

    // useEffect for call Api's 
    useEffect(() => {
        dispatch(countriesAction());
        dispatch(viewBuyer(id));
    }, [dispatch,id]);

    // get the countries list from reducer and set here
    const countriesList = useSelector((state) => state.countries.countries)
    useEffect(() => {
        if (countriesList && countriesList?.data && countriesList?.data?.status === true) {
            setCountryList(countriesList?.data?.data);
        }
    }, [countriesList]);

    // get buyer data via id and set it in state
    const buyerDtl = useSelector((state) => state.viewBuyer.viewBuyer);
    useEffect(() => {
        if(buyerDtl && buyerDtl.data && buyerDtl.data.status === true ){
            setBuyerDetails({
                id: buyerDtl.data.data.id, 
                buyer_name: buyerDtl.data.data.name, 
                email: buyerDtl.data.data.email, 
                address: buyerDtl.data.data.address, 
                city: buyerDtl.data.data.city, 
                country: buyerDtl.data.data.country, 
                phone_no: buyerDtl.data.data.phone_no
            });
        }
    }, [buyerDtl]);

    // updating stored value in state
    const handleBuyerFormDetails = (e) => {
        // Validate phone_no input against regex pattern
        if (e.target.name === 'phone_no' && !/^[0-9\-()+ ]{0,15}$/.test(e.target.value)) {
            return;
        }
        setBuyerDetails({
            ...buyerDetails, 
            [e.target.name]: e.target.value
        })
    }

    // function to create buyer
    const handleUpdateBuyer = async (e) => {
        e.preventDefault();
        if (!buyerDetails.buyer_name) {
            setError(true);
            return false;
        } else {
            dispatch(
                updateBuyer({
                    id      : buyerDetails?.id,
                    name    : buyerDetails?.buyer_name,
                    email   : buyerDetails?.email,
                    address : buyerDetails?.address,
                    city    : buyerDetails?.city,
                    country : buyerDetails?.country,
                    phone_no: buyerDetails?.phone_no,
                })
            );
        }
    };

    //select data from reducer and set toaster here
    const updateBuyerDtl = useSelector((state) => state.updateBuyer.updateBuyer)
    useEffect(() => {
        if (updateBuyerDtl && updateBuyerDtl?.data && updateBuyerDtl?.data?.status === true) {
            toast.success(updateBuyerDtl?.data?.message,{theme: "dark",});
            navigate("/buyers")
            dispatch(clearBuyerMsg());
        }
        if (updateBuyerDtl && updateBuyerDtl?.data && updateBuyerDtl?.data?.status === false) {
            toast.error(updateBuyerDtl?.data?.message,{theme: "dark",});
        }
    }, [updateBuyerDtl,navigate,dispatch]);

    return (
        <>
            <div className="dash-body">
                <div className="head-row">
                    <h3>Edit Buyer Details</h3>
                </div>
                <form onSubmit={handleUpdateBuyer}>
                    <div className="box-body box-shd">
                        <div className="row">
                            <div className="col-sm-6 col-lg-6 dash-form-col">
                                <label>Buyer Name<span className="text-danger">*</span></label>
                                <input className="form-control" type="text" id="buyer_name" 
                                    name="buyer_name"
                                    value={buyerDetails.buyer_name}
                                    onChange={handleBuyerFormDetails}
                                    placeholder="Enter Buyer Name" 
                                    maxLength="255"
                                    />
                                {error && !buyerDetails?.buyer_name && (
                                    <span style={{ color: "red" }} className="invalidInput" >
                                        Required*
                                    </span>
                                )}
                            </div>
                            <div className="col-sm-6 col-lg-6 dash-form-col">
                                <label>Address</label>
                                <input className="form-control" type="text" id="address" name="address"
                                    value={buyerDetails?.address || ''}
                                    onChange={handleBuyerFormDetails}
                                    placeholder="Enter Address"
                                    maxLength="255"
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 dash-form-col">
                                <label>Phone No.</label>
                                <input className="form-control" type="text"
                                    value={buyerDetails?.phone_no || ''}
                                    onChange={handleBuyerFormDetails}
                                    name="phone_no"
                                    placeholder="Enter No."
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 dash-form-col">
                                <label>Email</label>
                                <input className="form-control" type="email"
                                    value={buyerDetails.email || ''}
                                    onChange={handleBuyerFormDetails}
                                    name="email"
                                    placeholder="Enter Email"
                                    maxLength="255"
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 dash-form-col">
                                <label>Country</label>
                                <select className="form-control" onChange={handleBuyerFormDetails} name="country" value={buyerDetails.country || ''} >
                                    <option value="">--Select country--</option>
                                    {countryList.map((data,i) => (
                                        <option key={i} value={data.name}>{data.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-sm-6 col-lg-3 dash-form-col">
                                <label>City</label>
                                <input className="form-control"
                                    placeholder="Enter City"
                                    name="city"
                                    maxLength="255"
                                    value={buyerDetails?.city || ''}
                                    onChange={handleBuyerFormDetails}
                                />
                            </div>
                            <div className="dash-btn-group mt-2">
                                <button type="submit" className="cus-btn">Update</button>
                                <Link to="/buyers"><button className="cus-btn">Cancel</button></Link>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default BuyerUpdate;
